export default __webpack_public_path__ + "static/media/thermometer.6323ce30.png";